module.exports = __webpack_public_path__ + "assets/c8566ba62c4ac5d4df6ab45f68b5c412.png";